import React, { Component } from 'react';
import './App.css'

class ContactPage extends Component {
	render() {
		return (
			<div className="Contact-page">
				<b>mgmt</b><br></br>
				theo@nacremusic.com
			</div>
			);
	}
}

export default ContactPage;